import React from 'react';
import PropTypes from 'prop-types';
import './chatbot-widget.css'; // Ensure this path matches the actual file location

const propTypes = {
  src: PropTypes.string.isRequired,
};

const ChatbotWidget = ({ src = 'https://m0.quest/workspace/coding-en'}) => {
  
  return (
    <iframe
      id="chat-iframe"
      src={src}
      allow="clipboard-read; clipboard-write; microphone"
      title="Chat Widget"
      style={{ width: '100%', height: '100%', border: 'none' }}
    ></iframe>
  );
};

ChatbotWidget.propTypes = propTypes;

export default ChatbotWidget;


// WEBPACK FOOTER //
// ./src/templates/Challenges/components/ChatbotWidget.js